<template>
  <div class="orders_all">
    <div
      class="order_top font14 font_weight500 colo0 clearfix"
      @click="goList('/order/list', 0)"
    >
      <div class="left">我的订单</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div class="right font10 font_weight400 look_all">查看全部订单</div>
    </div>
    <div class="o_list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="o_item"
        @click="goList(item.path, item.OrderStatusValue)"
      >
        <div>
          <div class="img_back">
            <img :src="item.pic" class="order_img" />
          </div>
          <div class="item_t">{{ item.OrderStatusName }}</div>
        </div>
      </div>
      <div class="o_item" @click="goRefundList(saleAfter.path)">
        <div>
          <div class="img_back">
            <img :src="saleAfter.pic" class="order_img" />
          </div>
          <div class="item_t">{{ saleAfter.OrderStatusName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          OrderStatusName: "待付款",
          OrderStatusValue: 1,
          path: "/order/list",
          pic: require("@/assets/mine/icon_order1@2x.png")
        },
        {
          OrderStatusName: "待发货",
          OrderStatusValue: 2,
          path: "/order/list",
          pic: require("@/assets/mine/icon_order2@2x.png")
        },
        {
          OrderStatusName: "待收货",
          OrderStatusValue: 3,
          path: "/order/list",
          pic: require("@/assets/mine/icon_order3@2x.png")
        },
        {
          OrderStatusName: "已完成",
          OrderStatusValue: 4,
          path: "/order/list",
          pic: require("@/assets/mine/icon_order4@2x.png")
        }
      ],
      saleAfter: {
        OrderStatusName: "售后服务",
        OrderStatusValue: 7,
        path: "/order/refund/refundlist",
        pic: require("@/assets/mine/icon_order5@2x.png")
      }
    };
  },
  methods: {
    goList(url, index) {
      this.$emit("goList", url, index);
    },
    goRefundList(path) {
      this.$router.push(path);
    }
  }
};
</script>
<style lang="less" scoped>
.orders_all {
  position: relative;
  z-index: 1;
  margin: 14px 12px 0;
  // padding: 5px 12px 12px;
  background: #fff;
  border-radius: 6px;
  .order_top {
    line-height: 24px;
    padding: 8px 0;
    margin: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.06);
    .right_go {
      display: block;
      width: 24px;
    }
    .look_all {
      color: rgba(0, 0, 0, 0.55);
    }
  }
  .o_list {
    display: flex;
    flex-direction: row;
    padding: 5px 0;
  }
  .o_item {
    width: 25%;
    text-align: center;
    position: relative;
  }
  .item_pic {
    width: 20px;
    height: 20px;
  }
  .item_t {
    /* font-family: PingFangSC-Medium; */
    font-size: 12px;
    color: #222222;
    margin-top: 4px;
  }

  .img_back {
    position: relative;
  }
  .order_img {
    width: 21px;
  }
  .badge {
    position: absolute;
    top: -9px;
    left: calc(50% + 10px);
    width: 18px;
    line-height: 18px;
    background: #c19662;
    color: #fff;
    font-size: 12px;
    border-radius: 9px;
  }
  .item_num {
    position: absolute;
    top: -8px;
    right: 15px;
    background: linear-gradient(
      270deg,
      rgba(242, 77, 12, 1) 0%,
      rgba(242, 11, 0, 1) 100%
    );
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 9px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 12px;
    -webkit-transform: scale(0.84);
    transform-origin: 0 0;
    padding: 3px 5px;
  }
}
</style>
